<template>
  <button class="c-button c-button--default">
    <img class="c-button__left-icon" :src="assetsPath('emblem-white.svg')" alt="">
    Follow on Airbit
  </button>
</template>
<script>
export default {
  methods: {
    assetsPath(asset) {
      return `${ab.baseUrl}/img/webstore/${asset}`
    },
  }
}
</script>
